var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLedConfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ledConfIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 282",
    transform: "translate(599 46)",
    fill: "#a1a1a1",
    stroke: "#707070",
    d: "M0 0h36v36H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ledConfIcon_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 382",
    fill: "none",
    d: "M0 0h36v36H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "LEDIcon",
    transform: "translate(-599 -46)",
    clipPath: "url(#ledConfIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "LEDIcon",
    transform: "translate(599 46)",
    clipPath: "url(#ledConfIcon_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 380",
    fill: "#231815"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 534",
    d: "M30.487 20.471c-5.327 0-9.661-5.324-9.661-11.868a.225.225 0 10-.45 0c0 6.447-4.267 11.77-9.511 11.866a.229.229 0 00-.221.23.225.225 0 00.221.225c5.238.1 9.505 5.413 9.511 11.852a.225.225 0 00.45 0c.006-6.536 4.34-11.854 9.661-11.854a.225.225 0 000-.45"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 535",
    d: "M11.967 7.87c1.746.034 3.168 1.913 3.17 4.188a.225.225 0 00.45 0c0-2.31 1.446-4.189 3.22-4.189a.225.225 0 100-.45c-1.775 0-3.22-1.882-3.22-4.194a.225.225 0 10-.45 0c0 2.279-1.422 4.16-3.17 4.193a.226.226 0 000 .452"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 536",
    d: "M5.509 5.78a1.7 1.7 0 011.383 1.862.225.225 0 00.45 0c0-1.027.631-1.863 1.4-1.863a.225.225 0 100-.45c-.774 0-1.4-.837-1.4-1.865a.225.225 0 00-.45 0 1.7 1.7 0 01-1.383 1.865.225.225 0 100 .451"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 537",
    d: "M12.574 14.346a.225.225 0 00-.225-.225c-1.775 0-3.22-1.882-3.22-4.194a.225.225 0 10-.45 0c0 2.279-1.422 4.16-3.17 4.193a.226.226 0 000 .452c1.746.034 3.168 1.913 3.17 4.188a.225.225 0 00.45 0c0-2.31 1.446-4.189 3.22-4.189a.225.225 0 00.225-.225"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLedConfIcon);
export default __webpack_public_path__ + "static/media/ledConfIcon.267632c75621aef1.svg";
export { ForwardRef as ReactComponent };